<template>
  <div>
    <div>
      <div>
        <div class="mb-6">
          <!-- <div class="absolute left-4 top-4">
            <feather-icon icon="SearchIcon" class="text-primary" /> 
          </div> -->
          <base-input
            placeholder="Search for anything"
            class="w-full font-medium bannertext-input fsize16"
            v-model="search"
          />
        </div>
        <!-- <b-input
          placeholder="Search for anything"
          class="w-full font-medium bannertext-input fsize16"
          v-model="search"
        /> -->
      </div>
      <div v-if="filterData.length != 0">
        <section class="grid lg:grid-cols-3 md:gap-cols-3 gap-cols-1 gap-8">
          <b-card
            class="border-0 shadow-lg"
            no-body
            v-for="(item, index) in filterData"
            :key="index"
          >
            <div class="overflow-hidden hover-rad-tr relative">
              <div class="relative">
                <img
                  :src="$imageURL + '/' + item.icone"
                  alt="course-img"
                  class="w-full rounded-tl-lg rounded-tr-lg img-zoom card-topimg-h230 object-contain"
                />
                <!-- <feather-icon
                  icon="HeartIcon"
                  class="cursor-pointer text-primary bookmark"
                  :svgClasses="[isActive ? 'wishlistActive' : '']"
                  @click="isActive = !isActive"
                ></feather-icon> -->
              </div>

              <!-- <div class="card-rating">
                4.5 
                <i class="fa fa-star text-warning"></i>
              </div> -->
            </div>
            <b-card-text
              class="p-4 cursor-pointer"
              @click="courseDetail('e-course-detail', item)"
            >
              <div class="row">
                <div class="col-6">
                  <p class="font-semibold fsize12 sm-fsize12">
                    {{ item.chapter.length }} chapters
                  </p>
                </div>
                <div class="col-6 text-right">
                  <p class="font-semibold fsize12 sm-fsize12">
                    {{ item.duration }} h
                  </p>
                </div>
                <a
                  class="cursor-pointer text-primary bookmark"
                  v-if="
                    userData.role != 'admin' &&
                    userData.role != 'author' &&
                    userData.role != 'vendor'
                  "
                >
                  <template v-if="whishlistCheck(item._id)">
                    <feather-icon
                      icon="HeartIcon"
                      @click.stop="removeWishlist(item)"
                      class="cursor-pointer text-primary bookmark"
                      :svgClasses="'wishlistActive'"
                    ></feather-icon>
                  </template>
                  <template v-else>
                    <feather-icon
                      icon="HeartIcon"
                      class="cursor-pointer text-primary bookmark"
                      @click.stop="getWishlist(item)"
                    />
                  </template>
                </a>
              </div>
              <h4
                class="font-bold fsize18 sm-fsize18 mt-1.5 mb-2 ellipsis-2 text-black"
              >
                {{ item.name }}
              </h4>
              <div class="row">
                <div class="col-8" v-if="item.price != item.discountPrice">
                  <div class="flex items-center gap-2">
                    <span class="line-through fsize15 text-80808099">
                      ₹ {{ item.price }}
                    </span>
                    <span class="font-bold fsize16 sm-fsize12 text-black">
                      <template
                        v-if="
                          Object.keys(getUserByUserId).length !== 0 &&
                          Object.hasOwn(getUserByUserId, 'currentMembership')
                        "
                      >
                        &#8377;{{
                          (
                            item.discountPrice -
                            (getUserByUserId.currentMembership.discount / 100) *
                              item.discountPrice
                          ).toFixed(2)
                        }}
                      </template>
                      <template v-else>
                        &#8377;{{ item.discountPrice.toFixed(2) }}
                      </template>
                    </span>
                  </div>
                  <p class="font-bold fsize16 sm-fsize12 text-black">
                    <!-- ₹{{ item.discountPrice }} -->

                    <span class="text-success fsize14 font-medium">
                      <div
                        v-if="
                          Object.keys(getUserByUserId).length !== 0 &&
                          Object.hasOwn(getUserByUserId, 'currentMembership')
                        "
                      >
                        <span class="text-primary font-semibold">
                          {{
                            (
                              ((item.price - item.discountPrice) / item.price) *
                              100
                            ).toFixed(2)
                          }}% off +
                        </span>
                        <br />
                        <span
                          >{{
                            getUserByUserId.currentMembership.discount.toFixed(
                              2
                            )
                          }}% Membership Discount</span
                        >
                      </div>
                      <template v-else>
                        {{
                          (
                            ((item.price - item.discountPrice) / item.price) *
                            100
                          ).toFixed(2)
                        }}% off
                      </template>
                      <!-- {{
                        (
                          ((item.price - item.discountPrice) / item.price) *
                          100
                        ).toFixed(2)
                      }}% off -->
                    </span>
                  </p>
                </div>
                <div class="col-8" v-else>
                  <span class="font-bold fsize16 sm-fsize12 text-black">
                    <!-- Rs {{ item.price }} -->
                    <template
                      v-if="
                        Object.keys(getUserByUserId).length !== 0 &&
                        Object.hasOwn(getUserByUserId, 'currentMembership')
                      "
                    >
                      &#8377;{{
                        (
                          item.price -
                          (getUserByUserId.currentMembership.discount / 100) *
                            item.price
                        ).toFixed(2)
                      }}
                    </template>
                    <template v-else> &#8377;{{ item.price }} </template>
                    <span class="line-through fsize16 ml-2 mr-4 text-80808099">
                      <template
                        v-if="
                          Object.keys(getUserByUserId).length !== 0 &&
                          Object.hasOwn(getUserByUserId, 'currentMembership')
                        "
                      >
                        &#8377;{{ item.price.toFixed(2) }}
                      </template>
                    </span>
                  </span>
                  <p class="text-success fsize16 font-medium">
                    <template
                      v-if="
                        Object.keys(getUserByUserId).length !== 0 &&
                        Object.hasOwn(getUserByUserId, 'currentMembership')
                      "
                    >
                      {{
                        getUserByUserId.currentMembership.discount.toFixed(2)
                      }}% off
                    </template>
                  </p>
                </div>
                <div class="col-4 text-right">
                  <a
                    href="#"
                    v-if="
                      userData.role != 'admin' &&
                      userData.role != 'author' &&
                      userData.role != 'vendor'
                    "
                    ><i
                      class="fa fa-shopping-cart"
                      @click.stop="addToCart(item)"
                    ></i
                  ></a>
                </div>
              </div>
            </b-card-text>
          </b-card>
        </section>
      </div>
      <div v-else>
        <NoData />
      </div>
    </div>
  </div>
</template>
<script>
// import { map } from "d3";
import { mapState } from "vuex";
import NoData from "../NoData.vue";
export default {
  data() {
    return {
      // courses: [
      //   {
      //     id: "01",
      //     img: require("@/assets/images/courses/1.png"),
      //     rating: "4.9/5",
      //     time: "01h 49m",
      //     count: "5,957",
      //     name: "  Motion Graphics: Create a Nice Typography Animation",
      //     price: "33.99",
      //   },
      //   {
      //     id: "02",
      //     img: require("@/assets/images/courses/2.png"),
      //     rating: "4.9/5",
      //     time: "01h 49m",
      //     count: "5,957",
      //     name: "  Motion Graphics: Create a Nice Typography Animation",
      //     price: "33.99",
      //   },
      //   {
      //     id: "03",
      //     img: require("@/assets/images/courses/3.png"),
      //     rating: "4.9/5",
      //     time: "01h 49m",
      //     count: "5,957",
      //     name: "  Motion Graphics: Create a Nice Typography Animation",
      //     price: "33.99",
      //   },
      //   {
      //     id: "04",
      //     img: require("@/assets/images/courses/4.png"),
      //     rating: "4.9/5",
      //     time: "01h 49m",
      //     count: "5,957",
      //     name: "  Motion Graphics: Create a Nice Typography Animation",
      //     price: "33.99",
      //   },
      //   {
      //     id: "05",
      //     img: require("@/assets/images/courses/5.png"),
      //     rating: "4.9/5",
      //     time: "01h 49m",
      //     count: "5,957",
      //     name: "  Motion Graphics: Create a Nice Typography Animation",
      //     price: "33.99",
      //   },
      //   {
      //     id: "06",
      //     img: require("@/assets/images/courses/1.png"),
      //     rating: "4.9/5",
      //     time: "01h 49m",
      //     count: "5,957",
      //     name: "  Motion Graphics: Create a Nice Typography Animation",
      //     price: "33.99",
      //   },
      // ],
      courseData: [],
      search: "",
      wishlistData: [],
      cartData: [],
      isActive: false,
      isAdded: false,
    };
  },

  methods: {
    whishlistCheck(id) {
      if (this.get_singlestudent && this.get_singlestudent.wishlist) {
        let course = this.get_singlestudent.wishlist.map((e) => e);
        let wishList = course.map((e) => e.course[0]._id);
        if (
          Object.keys(this.get_singlestudent).length > 0 &&
          wishList.includes(id)
        ) {
          return true;
        } else {
          return false;
        }
      }
    },
    courseDetail(name, data) {
      this.$router.push({ name: name });
      this.$store.commit("eLearning/selectedCourseHome", data);
    },
    async getWishlist(items) {
      const token = sessionStorage.getItem("token");
      if (token == "" || token == undefined || token == null) {
        this.$swal.fire({
          title: "",
          text: "Please login to access this content",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return this.$router.push({ name: "signin" });
      }
      try {
        const { data } = await this.$store.dispatch("wishlist/AddWishlist", {
          course: items._id,
          type: "Course",
        });
        this.$notify({
          title: "Added",
          message: "Course add to wishlist!!",
          type: "success",
          duration: "2000",
        });
        await this.$store.dispatch(
          "student/getsinglestudent",
          this.userData.student._id
        );
        this.get_singlestudent.wishlist.forEach((ele) => {
          this.wishlistData.push(ele.course[0]._id);
        });
        // console.log(data);
      } catch (e) {
        // console.log(e.response.status == 500);
        if (e.response.status == 500) {
          this.$notify({
            title: "Already Exist",
            message: "Course already in wishlist!!",
            type: "info",
            duration: "2000",
          });
        }
      }
    },
    async removeWishlist(item) {
      // console.log(item._id);
      if (item._id.length != 0) {
        const index = this.wishlistData.indexOf(item._id);
        // console.log("this.wishlistData", this.wishlistData);
        // console.log(index);
        if (index > -1) {
          this.wishlistData.splice(index, 1);
          // console.log(this.wishlistData);
        }
        // this.$swal("Removed!", "Item has been removed.", "success");
        this.$swal.fire({
          title: "Removed!",
          text: "Item has been removed.",
          icon: "success",
          confirmButtonColor: "#830c81",
        });
        let checkArry = this.get_singlestudent.wishlist.filter((e) => {
          if (e.course.length > 0) {
            return e.course[0]._id == item._id;
          } else {
            return false;
          }
        });
        // console.log(this.get_singlestudent.wishlist)

        const { data } = this.$store.dispatch("wishlist/removeWishlist", {
          _id: checkArry[0]._id,
          wishlist: checkArry[0]._id,
          student: this.userData.student._id,
        });
        await this.$store.dispatch(
          "student/getsinglestudent",
          this.userData.student._id
        );
      }
      this.getAllStudents();
    },
    async getAllStudents() {
      const data = await this.$store.dispatch(
        "student/getsinglestudent",
        this.userData.student._id
      );

      this.wishlistData = this.get_singlestudent.wishlist;
    },
    async addToCart(item) {
      try {
        const { data } = await this.$store.dispatch("cart/AddCart", {
          type: "Course",
          course: item._id,
        });
        // console.log(data);
        this.$swal.fire({
          title: "Added To Cart!!!",

          text: "Added To Cart Successfully!",

          icon: "success",
          showConfirmButton: false,
          showCancelButton: false,
          timer: 2000,
        });
      } catch {
        this.$swal.fire({
          title: "Already Exist!!!",

          text: "Item is already in Cart!",

          icon: "warning",
          showConfirmButton: false,
          showCancelButton: false,
          timer: 2000,
        });
      }
    },
    searchData() {
      if (this.searchCourse != "") {
        this.search = this.searchCourse;
      }
    },
  },
  async mounted() {
    if (Object.keys(this.user).length != 0) {
      let payload = {
        userId: this.user._id,
      };
      const getUser = await this.$store.dispatch(
        "auth/getUserByUserId",
        payload
      );
      if (this.userData.student) {
        await this.$store.dispatch(
          "student/getsinglestudent",
          this.userData.student._id
        );
        this.get_singlestudent.wishlist.forEach((ele) => {
          this.wishlistData.push(ele.course[0]._id);
        });
      }
    }
    this.searchData();
  },
  computed: {
    ...mapState("auth", { user: "user", getUserByUserId: "getUserByUserId" }),
    ...mapState("eLearning", ["course"]),
    ...mapState("eLearning", ["searchCourse"]),
    ...mapState("auth", ["userData"]),
    ...mapState("student", ["get_singlestudent"]),

    filterData() {
      return this.course.filter((item) => {
        // console.log(item.name);
        // if (this.searchCourse != "") {
        //   this.search = this.searchCourse;
        // }
        return item.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
  },

  components: {
    NoData,
  },
};
</script>
<style>
.bookmark {
  position: absolute !important;
  top: 5px;
  right: 5px;
}

.wishlistActive {
  fill: #4f0a4b;
  stroke: #4f0a4b;
}
</style>
